const isLocal = false;

export const baseURL = isLocal
  ? 'http://localhost:3005'
  : 'https://api.artemidastudio.com';
